import React, { useEffect } from "react";
// import { useTranslation } from "react-i18next";

import Link from "@material-ui/core/Link";

import withUiContext from "../WithUiContext";
// import Separator from "../Separator";

import "../Main/index.scss";

const Footer = props => {
    // const { i18n } = useTranslation();

    // const [lng, setLng] = useState(currentLng || "en");

    // const currentLng = localStorage.getItem("lng");

    // const changeLanguage = e => {
    //     i18n.changeLanguage(e);
    //     setLng(e);

    //     localStorage.setItem("lng", e);
    // };

	useEffect(() => {
		props.ctx.setFooterHeight(
			document.getElementById("wfr-footer-component").clientHeight
		);
	});

	return (
        <footer
            className="main-footer"
            id="wfr-footer-component"
        >
            {/* <div>
				<span
                    style={{
                        color: lng === "id"
                            ? "#064F6B"
                            : "000",
                        cursor: "pointer"
                    }}
					onClick={() => changeLanguage("id")}
				>
					Bahasa Indonesia
				</span>
				<Separator />

				<span
                    style={{
                        color: lng === "en"
                            ? "#064F6B"
                            : "000",
                        cursor: "pointer"
                    }}
					onClick={() => changeLanguage("en")}
				>
					English
				</span>
			</div> */}

			<div>
				Made with <span style={{ color: "red" }}>&nbsp; &#10084; &nbsp;</span>{" "}
				by &nbsp;{" "}
                <Link
                    href="https://weefer.co.id"
                    target="_blank"
                    rel="noreferrer"
                >
                    Weefer
				</Link>
			</div>
		</footer>
	);
};

export default withUiContext(Footer);